import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import useValidatePhoneNumber from 'hooks/useValidatePhoneNumber';
import useValidateEmail from 'hooks/useValidateEmail';

export const GridProps = {
  xs: 12,
  sm: 6,
};

export const EMERGENCY_CONTACTS_FIELD_NAMES = {
  name: 'name',
  relationship: 'relationship',
  phoneNumber: 'phoneNumber',
  email: 'email',
  isOpen: 'isOpen',
};

export const NEW_EMERGENCY_CONTACT = {
  [EMERGENCY_CONTACTS_FIELD_NAMES.name]: '',
  [EMERGENCY_CONTACTS_FIELD_NAMES.relationship]: '',
  [EMERGENCY_CONTACTS_FIELD_NAMES.phoneNumber]: '',
  [EMERGENCY_CONTACTS_FIELD_NAMES.email]: '',
  [EMERGENCY_CONTACTS_FIELD_NAMES.isOpen]: true,
};

const useEmergencyContactsFields = ({ formId }) => {
  const intl = useIntl();
  const validateEmail = useValidateEmail();
  const validatePhoneNumber = useValidatePhoneNumber();

  return useMemo(
    () =>
      [
        {
          name: EMERGENCY_CONTACTS_FIELD_NAMES.name,
          label: intl.formatMessage({
            id: 'afforda.documentation.applicationSubmission.emergencyContacts.name',
          }),
          variant: 'text',
          placeholder: intl.formatMessage({
            id: 'afforda.documentation.applicationSubmission.emergencyContacts.name',
          }),
          rules: {
            required: true,
          },
          GridProps,
        },
        {
          name: EMERGENCY_CONTACTS_FIELD_NAMES.relationship,
          label: intl.formatMessage({
            id: 'afforda.documentation.applicationSubmission.emergencyContacts.relationship',
          }),
          variant: 'text',
          placeholder: intl.formatMessage({
            id: 'afforda.documentation.applicationSubmission.emergencyContacts.relationship',
          }),
          rules: {
            required: true,
          },
          GridProps,
        },
        {
          name: EMERGENCY_CONTACTS_FIELD_NAMES.phoneNumber,
          label: intl.formatMessage({
            id: 'afforda.documentation.applicationSubmission.emergencyContacts.phoneNumber',
          }),
          variant: 'phone',
          placeholder: intl.formatMessage({
            id: 'afforda.documentation.applicationSubmission.emergencyContacts.phoneNumber',
          }),
          rules: {
            required: true,
            validate: validatePhoneNumber,
          },
          GridProps,
        },
        {
          name: EMERGENCY_CONTACTS_FIELD_NAMES.email,
          label: intl.formatMessage({
            id: 'afforda.documentation.applicationSubmission.emergencyContacts.email',
          }),
          variant: 'email',
          placeholder: intl.formatMessage({
            id: 'afforda.documentation.applicationSubmission.emergencyContacts.email',
          }),
          rules: {
            required: true,
            validate: validateEmail,
          },
          GridProps,
        },
      ].map((field) => ({
        ...field,
        id: formId,
      })),
    [formId, intl, validateEmail, validatePhoneNumber],
  );
};

export default useEmergencyContactsFields;
